export default function feature(state) {
  return state.feature
}



// WEBPACK FOOTER //
// ./src/config/reducers/feature.js